<template>
  <v-app>    
    <v-content>
      <AppBar/>
      
        <v-container class="mt-10">
          <router-view/>
        </v-container>
    </v-content>
  </v-app>
</template>
<style>
</style>
<script>
import AppBar from '@/components/AppBar'

export default {
  name: 'App',
  data: () => ({
    //
  }),
  components: {
    AppBar
  },
  methods:{
    goback(){
      this.$router.go(-1);
    }
  },
};
</script>
